import styles from './LkmAppealDetailInfo.module.scss'

import { formatPrice } from 'helpers/formatPrice'
import { LkmAppealDetailResult } from 'feature/lkmAppeals/types'
import { FC } from 'react'
import { convertDataToStringWithMonth } from 'helpers/date/convertDataToStringWithMonth'
import { getTimeByTimeZone } from 'helpers/date/getTimeByTimeZone'
import parse from 'html-react-parser'
import { isOnlyWhitespaceOrNbsp } from 'helpers/checkIsOnlySpacesInText'
import { LkmAppealDetailInfoButtons } from '../lkmAppealDetailInfoButtons/LkmAppealDetailInfoButtons'

type LkmAppealDetailProps = {
  data: LkmAppealDetailResult
  isClientVisible: boolean
}
export const LkmAppealDetailInfo: FC<LkmAppealDetailProps> = ({
  data,
  isClientVisible,
}) => {
  const convertData = getTimeByTimeZone(data.installationDate)

  return (
    <div className={styles.appealInfo}>
      <div className={styles.appealInfo__infoBlocks}>
        <div className={styles.appealInfo__parametersList}>
          <div className={styles.appealInfo__parametersItem}>
            <span className='default-text'>Тип изделия:</span>
            <span className='default-text'>{data.productType}</span>
          </div>
          <div className={styles.appealInfo__parametersItem}>
            <span className='default-text'>Предложенная сумма:</span>
            <span className='default-text'>{formatPrice(data.sum)}</span>
          </div>
          <div className={styles.appealInfo__parametersItem}>
            <span className='default-text'>Диллер:</span>
            <span className='default-text'>{data.dealer}</span>
          </div>
          {data.client && isClientVisible && (
            <div className={styles.appealInfo__parametersItem}>
              <span className='default-text'>Клиент:</span>
              <span className='default-text'>{data.client}</span>
            </div>
          )}

          {data.comment && !isOnlyWhitespaceOrNbsp(data.comment) && (
            <div className={styles.appealInfo__parametersItem}>
              <span className='default-text'>Комментарий к заявке:</span>
              <p className='default-text'>{parse(data.comment)}</p>
            </div>
          )}
        </div>

        <LkmAppealDetailInfoButtons
          isAcceptButtonVisible={
            !data.confirmation && data.status === 'in_progress'
          }
          isRespondButtonVisible={!data.responded && data.status === 'new'}
          data={data}
        />
      </div>

      <div className={styles.appealInfo__infoBlocks}>
        <div className={styles.appealInfo__infoBlock}>
          <div className={styles.appealInfo__infoBlockTitle}>
            <span className='h4'>Адрес монтажа</span>
          </div>
          <div className={styles.appealInfo__infoBlockBody}>
            <span className='default-text'>{data.address}</span>
          </div>
        </div>
        <div className={styles.appealInfo__infoBlock}>
          <div className={styles.appealInfo__infoBlockTitle}>
            <span className='h4'>Дата монтажа</span>
          </div>
          <div className={styles.appealInfo__infoBlockBody}>
            <span className='default-text'>
              {convertDataToStringWithMonth(convertData, false, false)}
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
